import { createPanel } from '@atlassian/entry-point-panel';
import type { CreatePanel } from '@atlassian/entry-point-panel/types';

export const ConfigureStatusPanel: CreatePanel = createPanel();
